import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import logo from "../assets/images/logo/logo.png";

const sections = [
  { id: "home" }, // used only for logo + scroll detection
  { id: "feature", label: "Features" },
  { id: "how-it-works", label: "How It Works" },
  { id: "why-tiffintap", label: "Why Tiffintap" },
  { id: "testimonial", label: "Testimonials" },
  { id: "faqs", label: "FAQs" },
  { id: "contact", label: "Contact" },
];

const LandingHeader = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("");

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
    setIsOpen(false);
  };

  // Detect active section while scrolling
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 120;

      sections.forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (
            scrollPosition >= offsetTop &&
            scrollPosition < offsetTop + offsetHeight
          ) {
            setActiveSection(section.id);
          }
        }
      });
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className="w-full bg-white/80 backdrop-blur-md shadow-sm fixed top-0 left-0 z-50">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <div>
          <img
            src={logo}
            alt="logo"
            className="h-10 w-[175px] cursor-pointer"
            onClick={() => scrollToSection("home")}
          />
        </div>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          <ul className="flex gap-2 text-sm lg:text-sm xl:text-md font-medium relative">
            {sections
              .filter((item) => item.label) // 👈 hide home
              .map((item) => (
                <li
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`relative px-4 py-2 cursor-pointer transition-all duration-300 rounded-full ${
                    activeSection === item.id
                      ? "text-orange-600 bg-orange-50 shadow-sm"
                      : "text-black hover:text-orange-500"
                  }`}
                >
                  {item.label}

                  {/* Animated underline */}
                  {activeSection === item.id && (
                    <span className="absolute left-1/2 -bottom-1 w-2/3 h-[3px] bg-gradient-to-r from-orange-400 to-orange-600 -translate-x-1/2 rounded-full"></span>
                  )}
                </li>
              ))}
          </ul>

          <button className="px-6 py-3 rounded-full bg-orange-500 text-white font-medium hover:bg-orange-600 transition">
            Get Started
          </button>
        </nav>

        {/* Mobile Button */}
        <div className="lg:hidden">
          <button onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>
      </div>


      

      {/* Mobile Menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-500 ${
          isOpen
            ? "max-h-[500px] opacity-100 translate-y-0"
            : "max-h-0 opacity-0 -translate-y-2"
        }`}
      >
        <div className="bg-white shadow-md px-6 pb-6">
          <ul className="flex flex-col gap-4 font-medium mt-4">
            {sections
              .filter((item) => item.label) // 👈 hide home
              .map((item) => (
                <li
                  key={item.id}
                  onClick={() => scrollToSection(item.id)}
                  className={`px-4 py-2 rounded-lg cursor-pointer transition-all ${
                    activeSection === item.id
                      ? "bg-orange-100 text-orange-600"
                      : "text-gray-700 hover:text-orange-500"
                  }`}
                >
                  {item.label}
                </li>
              ))}
          </ul>

          <button className="w-full mt-6 py-3 rounded-full bg-orange-500 text-white font-medium hover:bg-orange-600 transition">
            Get Started
          </button>
        </div>
      </div>
    </header>
  );
};

export default LandingHeader;
